import {connect} from '@modifi/redux'
import {withSuspense} from '@modifi/plugin-onboarding'
import {compose} from 'ramda'
import {FeInputFieldStatus} from '@modifi/enums'

import {
  selectInitialRegistrationNumbersFormData,
  selectInitialRegistrationNumbersFormDataIsLoading,
  aInitializePage,
} from './store/form'
import {
  aSubmitPage,
  aResetPage,
  selectSubmitPending,
  selectSubmitErrorMessage,
} from './store/submit'
import {selectCombinedInputFieldStatusBySectionName} from '../../../modules/input-fields'
import {SECTION_REGISTRATION_NUMBERS} from '../../../constants/sections'
import {selectCompanyExternalId} from '../../../data/company'
import RegistrationNumbers, {RegistrationNumbersProps} from './RegistrationNumbers'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  RegistrationNumbersProps,
  | 'externalCompanyId'
  | 'initialFormData'
  | 'initialFormDataLoading'
  | 'updatePending'
  | 'errorMessage'
  | 'pageIsVerified'
> => {
  const externalCompanyId = selectCompanyExternalId(state)
  return {
    externalCompanyId,
    initialFormData: selectInitialRegistrationNumbersFormData(state),
    initialFormDataLoading:
      !externalCompanyId ||
      selectInitialRegistrationNumbersFormDataIsLoading(state, externalCompanyId),
    updatePending: selectSubmitPending(state),
    errorMessage: selectSubmitErrorMessage(state),
    pageIsVerified:
      selectCombinedInputFieldStatusBySectionName(state, SECTION_REGISTRATION_NUMBERS) ===
      FeInputFieldStatus.VERIFIED,
  }
}

const mapDispatchToProps = {
  initialize: aInitializePage,
  onSubmit: aSubmitPage,
  onDiscard: aResetPage,
}

export const RegistrationNumbersPage = compose(
  withSuspense(false),
  connect(mapStateToProps, mapDispatchToProps)
)(RegistrationNumbers)
